import React from 'react';
import { motion } from 'framer-motion';
import { Check, Circle } from 'lucide-react';

const steps = [
  { id: 1, name: 'Framework', description: 'Investment structure' },
  { id: 2, name: 'Allocation', description: 'Asset distribution' },
  { id: 3, name: 'Behaviour', description: 'Decision patterns' },
];

const ProgressStepper = ({ currentStep }) => {
  return (
    <nav aria-label="Progress" className="w-full" data-testid="progress-stepper">
      <ol className="flex items-center justify-between">
        {steps.map((step, stepIdx) => (
          <li key={step.name} className="relative flex-1">
            {stepIdx !== steps.length - 1 && (
              <div className="absolute left-0 top-5 w-full pr-4" aria-hidden="true">
                <div className="h-0.5 w-full bg-[#E2E8E8]">
                  <motion.div
                    className="h-0.5 bg-[#4CB860]"
                    initial={{ width: '0%' }}
                    animate={{ width: currentStep > step.id ? '100%' : '0%' }}
                    transition={{ duration: 0.5, ease: 'easeInOut' }}
                  />
                </div>
              </div>
            )}
            <div className="group relative flex flex-col items-center">
              <span className="flex h-10 items-center">
                <motion.span
                  className={`relative z-10 flex h-10 w-10 items-center justify-center rounded-full border-2 transition-colors duration-300 ${
                    currentStep > step.id
                      ? 'border-[#4CB860] bg-[#4CB860]'
                      : currentStep === step.id
                      ? 'border-[#005858] bg-white'
                      : 'border-[#E2E8E8] bg-white'
                  }`}
                  initial={{ scale: 1 }}
                  animate={{ scale: currentStep === step.id ? 1.1 : 1 }}
                  transition={{ duration: 0.2 }}
                  data-testid={`step-indicator-${step.id}`}
                >
                  {currentStep > step.id ? (
                    <Check className="h-5 w-5 text-white" />
                  ) : currentStep === step.id ? (
                    <span className="h-2.5 w-2.5 rounded-full bg-[#005858]" />
                  ) : (
                    <Circle className="h-3 w-3 text-[#E2E8E8]" />
                  )}
                </motion.span>
              </span>
              <span className="mt-3 text-center">
                <span
                  className={`block text-sm font-semibold ${
                    currentStep >= step.id ? 'text-[#005858]' : 'text-[#787A7A]'
                  }`}
                >
                  {step.name}
                </span>
                <span className="hidden sm:block text-xs text-[#787A7A] mt-1">
                  {step.description}
                </span>
              </span>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default ProgressStepper;
